import React from "react";
import ResourcesComponent from "../components/Resources";
import NavBar from "../components/NavBar";

const Activities = () => {
  return (
    <>
      <NavBar id="resources" />
      <ResourcesComponent />
    </>
  );
};

export default Activities;
